import { useFormContext } from 'react-hook-form';

import type { BrandFormSchema } from './schemas';

export const useBrandFormContext = () => {
  const context = useFormContext<BrandFormSchema>();

  return context;
};
